import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  RESET_FORGOT_PASSWORD_STATE,
} from "../../actionTypes/forgotPassword";

export interface ForgotPasswordState {
  loading: boolean;
  data: string;
  error: string | null;
  success: boolean;
}

export interface ForgotPasswordAction {
  type: string;
  payload: string;
}

const initialState: ForgotPasswordState = {
  loading: false,
  data: "",
  error: null,
  success: false,
};

const forgotPassword = (
  state = initialState,
  action: ForgotPasswordAction,
): ForgotPasswordState => {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:
      return { ...state, loading: true, error: null };
    case FORGOT_PASSWORD_SUCCESS:
      return { ...state, loading: false, data: action.payload, success: true };
    case FORGOT_PASSWORD_FAILURE:
      return { ...state, loading: false, error: action.payload || null };
    case RESET_FORGOT_PASSWORD_STATE:
      return initialState;
    default:
      return state;
  }
};

export default forgotPassword;
